import { createStyles } from '@mantine/core';
import { getTypographyStyles } from '../../theme/themeConfig';

export const useStyles = createStyles((theme) => {
  const { colors } = theme.other;
  return {
    contentContainer: {
      padding: '10px 20px',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      [`@media (max-width: ${theme.breakpoints.xs})`]: {
        paddingTop: 0,
      },
    },
    mobileInputWrapper: {
      position: 'relative',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      fontWeight: 500,
      fontSize: '20px',
    },
    inputLeftIcon: {
      position: 'absolute',
      left: 24,
    },
    mobileInput: {
      height: '45px',
      border: `1px solid ${colors.disabled.muted}`,
      borderRadius: '4px',
      width: '100%',
      padding: '12px 24px 12px 64px',
      outlineColor: colors.primary.default,
    },
    inputDescription: {
      ...getTypographyStyles('content_xs_regular'),
      color: colors.fg.muted,
      marginTop: '8px',
    },
    inputError: {
      color: 'red',
    },
    inputLeft: {
      fontWeight: 500,
      fontSize: '16px',
    },
    changeNumberLink: {
      marginTop: 'auto',
      marginBottom: '20px',
      color: '#1DBBF0',
    },
    tAndCLink: {
      color: colors.fg.muted,
      textDecoration: 'underline',
      ':hover': {
        color: colors.primary.default,
      },
    },
  };
});

export default useStyles;
